import React from 'react';
import styled from "styled-components";


export const Burger = ({ open, setOpen }) => {
    return (
      <StyledBurger className="burger-button" open={open} onClick={() => setOpen(!open)}>
        <div className='burger-item'/>
        <div className='burger-item'/>
        <div className='burger-item'/>
      </StyledBurger>
    )
}
const StyledBurger = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;

  &:focus {
    outline: none;
  }

  .burger-item {
    width: 30px;
    height: 3px;
    background: ${(props) => props.theme.burger_color};
    border-radius: 4px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    :nth-child(2) {
      opacity: ${({ open }) => open ? '0' : '1'};
      transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
    }

    :nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`;